import axios from 'axios';

const baseApiControllerUrl = '/api';

//#region [GET] GetUser 
export interface GetUserResponse {
    oid: string;
    email: string;
    firstName: string;
    lastName: string;
    fiscalCode: string;
}
export const GetUser = () =>
    axios.get<GetUserResponse>(`${baseApiControllerUrl}/GetUser`);
//#endregion

//#region [POST] AddClient 
interface AddClientRequest {
    vatCode: string;
}
interface AddClientResponse {
    registryStatus: {
        companyCode: string | null;
        installationCode: string | null;
        environmentCode: string | null;
        uri: string;
    };
    commands: {
        oid: string;
        name: string;
        rDProcedures: {
            oid: string;
            applicationCommands: string[];
        }[];
        eventHandler: string;
        expirationDateTime: string;
        parameters: {
            key: string;
            value: string;
        }[];
    }[];
}

export const AddClient = (request: AddClientRequest) =>
    axios.post<AddClientResponse>(`${baseApiControllerUrl}/addClient`,
    {
        "hostName": "TEST IT GAINSIGHT",
        "newExperienceIdentifier": "TEST IT GAINSIGHT",
        "customer": {
            "company": {
                "vatCode": request.vatCode
            }
        },
        "productConfigurations": [
            {
                "COMMENTO": "MULTI",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "f07b408a-5644-40ad-baaa-6fcc8edb33a9"
                }
            },
            {
                "COMMENTO": "DIRED24",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "001bf4c6-069b-4ab4-860f-42d3c1684596"
                }
            },
            {
                "COMMENTO": "012025000",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "246258ac-93c2-4609-884c-7445534fa7dd"
                }
            },
            {
                "COMMENTO": "023016014",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "c0543f81-d1b9-44fd-bff4-15a5ec7e90dc"
                }
            },
            {
                "COMMENTO": "002037002",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "9744cf41-c1ab-4b30-85e6-f23d191cab45"
                }
            },
            {
                "COMMENTO": "FA5B7B30-4D97-4C85-8FFF-EE16A14446EB",
                "type": "IAAS",
                "productRegistry": {
                    "procedureOid": "f4774237-2140-44c8-ac95-47265f89f634"
                }
            },
            {
                "COMMENTO": "0AB7A40C-F94F-40E5-9ACE-A8AEA8F67FD1",
                "type": "IAAS",
                "productRegistry": {
                    "procedureOid": "b2f490a8-6652-4483-a79c-3ab131dc13a5"
                }
            },
            {
                "COMMENTO": "W003C310",
                "type": "SAAS",
                "productRegistry": {
                    "procedureOid": "88013020-35ba-4651-8bbd-229abaeb26c4"
                }
            },
            {
                "COMMENTO": "1141582C-A58E-45DC-B26B-07F45F01DC9C",
                "type": "IAAS",
                "productRegistry": {
                    "procedureOid": "a6043e5d-ebe9-4b3e-b8df-ab2fcbeedfeb"
                }
            },
            {
                "COMMENTO": "8518B40A-EA7F-4133-91E9-913EFA413256",
                "type": "SAAS",
                "productRegistry": {
                    "procedureOid": "714441eb-d508-4e79-b5e5-89e478d414ce"
                }
            },
            {
                "COMMENTO": "5B451DF7-5282-4EB7-AFAB-04AE7F83ED67",
                "type": "ON PREMISES",
                "productRegistry": {
                    "procedureOid": "39a1ea5f-3663-425b-80bf-fe1201f5a547"
                }
            }
        ]
    }
);
//#endregion

/**
 * Temporanea, chiamata per recuperare i dati dell'utente e company da
 * inviare a gainsight
 * @param param0
 * @returns
 */
//#region [GET] GetUserProfile
interface GetUserProfileRequest {
    vatCode: string;
}
export interface GetUserProfileResponse {
    audience: {
        id: string;
        email: string;
        firstName: string;
        lastName: string;
    };
    account: {
        id: string;
        name: string;
        tsX_piva: string;
    };
}
export const GetUserProfile = (request: GetUserProfileRequest) => 
    axios.get<GetUserProfileResponse>('/api/GetUserProfile', {
        params: {
            vatCode: request.vatCode
        }
    });
//#endregion
